/**
 * Utilities for color manipulation and conversion.
 */

/**
 * Converts a Hex or RGB/RGBA color string to an RGBA string with the specified opacity.
 * 
 * @param color - The input color string (e.g., "#ff0000", "rgb(255, 0, 0)").
 * @param opacity - The desired opacity (0.0 to 1.0).
 * @returns An RGBA string (e.g., "rgba(255, 0, 0, 0.5)").
 */
export function withOpacity(color: string, opacity: number): string {
  if (!color) return `rgba(0, 0, 0, ${opacity})`;

  // Handle Hex
  if (color.startsWith("#")) {
    let hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex.split("").map(c => c + c).join("");
    }
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  // Handle RGB/RGBA
  const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
  if (match) {
    return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${opacity})`;
  }

  // Fallback for named colors or other formats
  return color;
}
